import React, { useEffect, useRef, useState } from "react";
import { useCart, useCartDispatch } from "../Contexts/CartProvider";
import "./Card.css";

const Card = (props) => {
  let dispatch = useCartDispatch();
  let data = useCart();
  const priceRef = useRef();
  let priceOptions = Object.keys(props.options);
  const [quantity, setQuantity] = useState(1);
  const [size, setSize] = useState("");

  const handleCart = async () => {
    let food = [];
    for (const item of data) {
      if (item.id === props.foodItems._id) {
        food = item;
        break;
      }
    }

    if (food !== 0) {
      if (food.size === size) {
        await dispatch({ type: "UPDATE", id: props.foodItems._id, price: finalPrice, quantity: quantity })
        return
      }

      else if (food.size !== size) {
        await dispatch({
          type: "ADD",
          id: props.foodItems._id,
          name: props.foodItems.name,
          price: finalPrice,
          img: props.foodItems.img,
          quantity: quantity,
          size: size,
        });
        return
      }
      return
    }
    await dispatch({
      type: "ADD",
      id: props.foodItems._id,
      name: props.foodItems.name,
      price: finalPrice,
      img: props.foodItems.img,
      quantity: quantity,
      size: size,
    });
  };

  useEffect(() => {
    setSize(priceRef.current.value);
  }, [])
  let finalPrice = quantity * parseInt(props.options[size])
  return (
    <div>
      <div className="card">
        <img
          className="card-food-image"
          src={props.foodItems.img}
          alt="food Card"
        />
        <div className="card-content">
          <div>
            <h2 className="card-title">{props.foodItems.name}</h2>
            <p className="card-description">{props.foodItems.description}</p>
          </div>
          <div>
            <select
              className="card-select"
              onChange={(e) => setQuantity(e.target.value)}
            >
              {Array.from(Array(6), (e, i) => {
                return (
                  <option key={i} value={i + 1}>
                    {i + 1}
                  </option>
                );
              })}
            </select>
            <select
              className="card-select"
              onChange={(e) => setSize(e.target.value)}
              ref={priceRef}
            >
              {priceOptions.map((data) => {
                return (
                  <option key={data} value={data}>
                    {data}
                  </option>
                );
              })}
            </select>
            <div className="total-price">₹{finalPrice}/-</div>
          </div>
          <hr className="card-hr" />
          <button className="add-to-cart" onClick={handleCart}>
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default Card;
